<template>
  <i18n-t v-if="dates" keypath="{fromDate} - {toDate}">
    <template #fromDate>
      <pu-utc-date
        :date="dates.arrive"
        :options="{ day: 'numeric', month: 'short' }"
      />
    </template>
    <template #toDate>
      <pu-utc-date
        :date="dates.depart"
        :options="{ day: 'numeric', month: 'short' }"
      />
    </template>
  </i18n-t>
</template>

<script lang="ts">
import { ArriveDepartIso } from '../../../search/types'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class SearchWizardHomepageBannerOptionsDates extends Vue {
  @Prop({ required: true, type: [Object, String] })
  dates: ArriveDepartIso | ''
}

export default toNative(SearchWizardHomepageBannerOptionsDates)
</script>
